import names from '../../data/visitorNames.json';
import { cyrb53 } from '../core/hash';

export function townspersonName(id: string, sex: 'm' | 'f'): string {
  const pool = names[sex === 'f' ? 'female' : 'male'];
  const name = pool[cyrb53(id) % pool.length];
  if (!name) throw new Error('The townsperson name register is empty');
  return name;
}
